import { useState, useContext, useEffect } from 'react';
import {
  TextField,Button,
  Typography,
  Box,
  Container,
  InputAdornment,
  IconButton,
} from '@mui/material';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { LoginFormContext } from '../../../context/login/LoginContext';
import { AuthContext } from '../../../context/AuthContext';
import logo from '../../../assets/logo.png';
import { useNavigate } from "react-router-dom";
const appUrl = process.env.REACT_APP_URL_BACKEND;

export const Form = () => {
  const { postLoginData, error } = useContext(LoginFormContext);
  const { empresaData } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    sel_username: '',
    sel_pass: '',
    rememberMe: false,
  });
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        sel_username: error.message.includes('usuario') ? error.message : '',
        sel_pass: error.message.includes('Clave') ? error.message : '',
      }));
    }
  }, [error]);

  const validateInput = (name, value) => {
    if (!value) {
      const messages = {
        sel_username: 'Por favor ingrese su usuario',
        sel_pass: 'Por favor ingrese su contraseña',
      };
      return messages[name];
    }
    return '';
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const inputValue = type === 'checkbox' ? checked : value;

    setFormData((prevForm) => ({
      ...prevForm,
      [name]: inputValue,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateInput(name, inputValue),
    }));
  };

  const handleSendData = async (event) => {
    event.preventDefault();

    const validationErrors = Object.keys(formData).reduce((acc, key) => {
      const error = validateInput(key, formData[key]);
      if (error) acc[key] = error;
      return acc;
    }, {});

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const res = await postLoginData(formData)
      if (res?.data?.mensaje) {
        setErrors(res.data.mensaje)
      } else {
        setErrors('Respuesta inesperada del servidor.')
      }
      if (res?.data?.token) {
       navigate('/'); // Redirige al
      }

    } catch (err) {
      // aquí caen los 400/401...
      const msg =
        err.response?.data?.mensaje ||
        'Usuario o contraseña inválidos'
      setErrors(msg)
    }
  };

  return (
    <Container component="main" className="LoginForm" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: 'background.paper',
          padding: 3,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <div
          style={{
            margin: '20px auto',
            backgroundColor: '#e0e0e0',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100px',
          }}
        >
          <img
            src={empresaData?.imagen_sitio ? appUrl + empresaData.imagen_sitio : logo}
            alt="Logo"
            style={{
              width: '100%',
              height: '100%',  // Aseguramos que la imagen ocupe todo el alto del contenedor
              objectFit: 'cover',  // Mantiene la relación de aspecto sin deformar la imagen
            }}
          />
        </div>

        <Typography component="h1" variant="h5">
          Iniciar Sesión
        </Typography>
        <Box component="form" noValidate sx={{ mt: 1 }} onSubmit={handleSendData}>
          <InputField
            id="sel_username"
            label="Usuario"
            type="text"
            placeholder="Ingrese su usuario"
            value={formData.sel_username}
            onChange={handleInputChange}
            startIcon={<AccountBoxIcon />}
            error={errors.sel_username}
          />
          <PasswordField
            id="sel_pass"
            label="Contraseña"
            placeholder="••••••••"
            value={formData.sel_pass}
            onChange={handleInputChange}
            showPassword={showPassword}
            onTogglePassword={() => setShowPassword(!showPassword)}
            error={errors.sel_pass}
          />

          <SubmitButton />
        </Box>
      </Box>
    </Container>
  );
};

const InputField = ({ id, label, type, placeholder, value, onChange, startIcon, error }) => (
  <TextField
    margin="normal"
    fullWidth
    id={id}
    label={label}
    type={type}
    name={id}
    value={value}
    onChange={onChange}
    autoComplete={id}
    placeholder={placeholder}
    required
    error={!!error}
    helperText={error}
    variant="outlined"
    InputProps={{
      startAdornment: startIcon ? (
        <InputAdornment position="start">{startIcon}</InputAdornment>
      ) : null,
    }}
  />
);

const PasswordField = ({
  id,
  label,
  placeholder,
  value,
  onChange,
  showPassword,
  onTogglePassword,
  error
}) => (
  <TextField
    margin="normal"
    fullWidth
    id={id}
    label={label}
    type={showPassword ? 'text' : 'password'}
    name={id}
    value={value}
    onChange={onChange}
    autoComplete={id}
    placeholder={placeholder}
    required
    error={!!error}
    helperText={error}
    variant="outlined"
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <IconButton
            onClick={onTogglePassword}
            edge="start"
            tabIndex={-1} // ← evita que se seleccione al usar tab
          >
            {showPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </InputAdornment>
      )
    }}
  />
);

const SubmitButton = () => (
  <Button
    type="submit"
    fullWidth
    variant="contained"
    sx={{
      mt: 3,
      mb: 2,
      backgroundColor: '#6439ff',
      '&:hover': {
        backgroundColor: '#4c28d6',
      },
    }}
  >
    Ingresar
  </Button>
);

export default Form;
